module.exports = __webpack_public_path__ + "static/media/invitePng.2950f2a2.png";